import { render } from "./BrdcmStatsPage.vue?vue&type=template&id=5140908c&ts=true"
import script from "./BrdcmStatsPage.vue?vue&type=script&lang=ts"
export * from "./BrdcmStatsPage.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__